import { type IInstructionFeedback } from "@/interfaces/api/instruction-feedback.interface"
import { type IInstruction } from "@/interfaces/api/instruction.interface"
import { BaseRepository } from "@/repositories/base-repository"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"
import type { IRepositoryRequestConfig } from "@/interfaces/repository/repository-request-config.interface"

export class InstructionFeedbackRepository extends BaseRepository<IInstructionFeedback> {
  resourcePath = "planning/instruction-feedbacks"

  async saveToInstruction(
    instruction: IInstruction,
    instructionFeedback: IInstructionFeedback,
    requestConfig?: IRepositoryRequestConfig
  ) {
    const httpRequestBuilder = new HTTPRequestBuilder(
      HTTPMethods.POST,
      `planning/instructions/${instruction.id}/feedback/`
    )
      .setExpectedStatusCode(201)
      .setData(instructionFeedback)
      .addStatusCodeHandlers(requestConfig?.statusCodeHandlers)

    return await httpRequestBuilder.build().execute()
  }

  public async confirmChanges(
    instructionFeedback: IInstructionFeedback,
    requestConfig?: IRepositoryRequestConfig
  ) {
    const httpRequestBuilder = new HTTPRequestBuilder(
      HTTPMethods.PUT,
      `planning/instruction-feedbacks/${instructionFeedback.id}/confirm/`
    )
      .setExpectedStatusCode([200, 404])
      .addStatusCodeHandlers(requestConfig?.statusCodeHandlers)

    return await httpRequestBuilder.build().execute()
  }
}
